import React, { useEffect, useState } from 'react';
import './Information.scss';
import { Button, Switch } from 'antd';
import { EditFilled, RedoOutlined } from '@ant-design/icons';
import VehicleInfoPopup from './VehicleInfoPopup';
import RankBenefitPopup from './RankBenefitPopup';
import WarrantyHistoryPopup from './WarrantyHistoryPopup';
import * as customerApi from '../../../api/customer/customerApi';
import { avatarDefault } from '../../../components/ExportImgFigma';
import { URL_CUSTOMER } from '../../../env';
import * as historyApi from '../../../api/history/historyApi';
import { useNavigate, useParams } from 'react-router-dom';
import useToast from '../../../hook/useToast';
import { ICardCustomer, getInfoCardCustomer } from '../../../api/rank/rankApi';
import RelativeCard from '../../../components/Relative/PoolingRelativeCard';
import PoolingDataHistoryCard from './PoolingDataHistoryCard';
import CarListCard, { DataType, DataTypeInterestedCar } from './HistoryCarList';
import OrderHistoryDrawer from '../Component/Drawer/OrderHistory';
import WarrantyHistoryDrawer from '../Component/Drawer/WarrantyHistory';
import FavoriteCarDrawer from '../Component/Drawer/FavoriteCar';
import OwnedCarDrawer from '../Component/Drawer/OwnedCar';
import * as selectOptionsApi from '../../../api/selectOptions/selectOptionsApi';
import { checkIsViewAndIsEdit, fommatSelectOption, getTitleSelectOption } from '../../../until';
import * as relativesApi from '../../../api/relatives/relativesApi';
import useLoading from '../../../hook/useLoading';

import * as businessApi from '../../../api/business/businessApi';
import BusinessCard from '../../../components/Relative/PoolingBusinessCard';
import { restoreCustomer } from '../../../api/recycleCustomer/recycleCustomerApi';
import ModalRestoreCustomer from '../RecycleBin/Component/Modal/ModalRestoreCustomer';
import { IPermissionCustomer } from '../../../api/groupPermission/groupPermissionApi';

interface Props {
  infoCustomer?: customerApi.ICustomerDetail_V4;
  permissionCustomerView?: IPermissionCustomer
  value?: any
  onChange?: (data: any, type: string) => void;
}
const InformationTab: React.FC<Props> = ({
  infoCustomer, permissionCustomerView, value, onChange
}) => {
  const pushLoading = useLoading()
  const navigator = useNavigate()
  const pushToast = useToast()

  useEffect(() => {
    gSLTypePhone()

  }, [])

  const [isShowAllPhoneNumber, setShowAllPhoneNumber] = useState(false)
  const [isShowAllSource, setShowAllSource] = useState(false)
  const [isShowAllSourcePhone, setShowAllSourcePhone] = useState(false)
  const [isShowAllSourceEmail, setShowAllSourceEmail] = useState(false)
  const [isBenefitPopupShow, setBenefitPopupShow] = useState(false)
  const [isWarrantyHistoryShow, setWarrantyHistoryShow] = useState(false)
  const [isInfoPopupShow, setInfoPopupShow] = useState(false)
  const [openRestoreListCustomer, setOpenRestoreListCustomer] = useState(false)

  const [dataHistoryMaintenance, setDataHistoryMaintenance] = useState<historyApi.IHistoryMaintenance[]>()
  const [data, setData] = useState<historyApi.IHistoryCarDetail>()

  const [sLTypePhone, setSLTypePhone] = useState<selectOptionsApi.ISelectOption[]>([])

  const [infoCardCustomer, setInfoCardCustomer] = useState<ICardCustomer>()

  const [listRelativeCustomer, setListRelativeCustomer] = useState<relativesApi.IRelationship_V2[]>([])//CN
  const [listBusiness, setListBusiness] = useState<businessApi.IBusiness[]>([])//CN
  const [listBusinessCustomer, setListBusinessCustomer] = useState<businessApi.IListBusinessCustomers[]>([])//GN

  const [listCarInUseHistory, setListCarInUseHistory] = useState<DataType[]>([])
  const [listCarOwnerShip, setListCarOwnerShip] = useState<DataType[]>([])
  const [listCarInterested, setListCarInterested] = useState<DataTypeInterestedCar[]>([])

  const [infoCarInUseHistory, setInfoCarInUseHistory] = useState<customerApi.IHistoryCarInUseDetail>()
  const [inforCarInterested, setInforCarInterested] = useState<customerApi.ICarInterested>()

  const gSLTypePhone = async () => {
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const glistRelativeCustomer = async () => {
    // if (infoCustomer?.businessCheck === undefined)
    //   return
    // const result = await relativesApi.getlistRelativeCustomer(Number(infoCustomer?.id), infoCustomer.businessCheck)
    // if (result?.status) {
    //   setListRelativeCustomer(result.data)
    // } else {
    //   setListRelativeCustomer([])
    //   pushToast(result?.message, 'error', 1000)
    // }
  }

  const glistBusinessCustomer = async () => {
    const result = await businessApi.getListBusiness(Number(infoCustomer?.id))
    if (result?.status) {
      setListBusiness(result.data)
    } else {
      setListBusiness([])
      pushToast(result?.message, 'error', 1000)
    }
  }


  // danh sách lịch sử xe đang sử dụng
  const gLisCarInUseHistory = async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await historyApi.gLisCarInUseHistory(historyApi.CarInUseHistory, pageSize, pageCurent, Number(infoCustomer?.id))

    if (result?.status) {

      setListCarInUseHistory(convertDataCarInUse(result.data, pageCurent, pageSize))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }
  // danh sách lịch sử xe sở hữu
  const gListCarOwnerShip = async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await historyApi.gLisCarInUseHistory(historyApi.CarOwnerShip, pageSize, pageCurent, Number(infoCustomer?.id))

    if (result?.status) {

      setListCarOwnerShip(convertDataCarInUse(result.data, pageCurent, pageSize))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }
  const convertDataCarInUse = (data: historyApi.IHistoryCarInUse[], pageCurent: number, pageSize: number) => {

    const convertData = data.map((item) => ({
      key: item.id,
      carName: item.carName,
      carImage: item.carImage,
      typeCar: item.typeCar,
      categoryCar: item.categoryCar,
      carLines: item.carLines,
      datePurchaseCar: item.datePurchaseCar,
      datePickUpCar: item.datePickUpCar,
      yearManufacture: item.yearManufacture,
      VIN: item.VIN,
      categoryCarImage: item.categoryCarImage
    }))
    return convertData
  }
  // thông tin xe đang sử dụng
  const getInforCarInUseHistory = async (id: number) => {
    const result = await customerApi.getInforCarInUseHistory(id)

    if (result?.data) {
      setShowOwnedCarDrawer(true)
      setInfoCarInUseHistory(result.data)
    } else {
      pushToast(result.message, "warning")
    }
  }
  // danh sách xe sở hữu

  // danh sách xe quan tâm
  const gLisCarInterested = async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await historyApi.gLisCarInterested(pageSize, pageCurent, Number(infoCustomer?.id))

    if (result?.status) {

      setListCarInterested(convertDataCarInterested(result.data, pageCurent, pageSize))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }
  const convertDataCarInterested = (data: historyApi.ICarInterested[], pageCurent: number, pageSize: number) => {

    const convertData = data.map((item) => ({
      key: item.id,
      carName: item.car.title,
      carImage: item.car.image,
      typeCar: item.typeVehicle?.title,
      categoryCar: item.categoryCar.title,
      carLines: item.carLine.title,
      datePurchaseCar: undefined,
      datePickUpCar: undefined,
      categoryCarImage: item.categoryCar.image
    }))
    return convertData
  }
  // thông tin xe quan tâm
  const getInforCarInterested = async (id: number) => {
    const result = await customerApi.getInforCarInterested(id)

    if (result?.data) {
      setShowFavoriteCarDrawer(true)
      setInforCarInterested(result.data)
    } else {
      pushToast(result.message, "warning")
    }
  }

  const showAllPhoneNumber = () => {
    setShowAllPhoneNumber(!isShowAllPhoneNumber)
  }

  const showAllSource = () => {
    setShowAllSource(!isShowAllSource)
  }

  const showAllSourcePhone = () => {
    setShowAllSourcePhone(!isShowAllSourcePhone)
  }

  const showAllSourceEmail = () => {
    setShowAllSourceEmail(!isShowAllSourceEmail)
  }

  const resultSubmitFormModalAddRelative = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      glistRelativeCustomer()
    } else {
      pushToast(message, 'error')
    }
  }


  //DN
  const resultSubmitFormModalAddBusiness = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      glistBusinessCustomer()
    } else {
      pushToast(message, 'error')
    }
  }

  //DN2
  const resultSubmitFormModalAddBusinessCustomer = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      // gListCustomer()
    } else {
      pushToast(message, 'error')
    }
  }




  const onConfirmRestore = async () => {
    const result = await restoreCustomer([Number(infoCustomer?.id)])
    if (result?.status) {
      pushToast(result.message, "success")
      setOpenRestoreListCustomer(false)
      navigator("/customer/recyclebin")
    } else {
      pushToast(result?.message, "warning")
    }
  }

  // CAR LIST
  const [showOwnedCarDrawer, setShowOwnedCarDrawer] = useState(false)
  const [showOwnedShipCarDrawer, setShowOwnedShipCarDrawer] = useState(false)
  const [showFavoriteCarDrawer, setShowFavoriteCarDrawer] = useState(false)

  // WARRANTY HISTORY
  const [showWarrantyHistoryDrawer, setShowWarrantyHistoryDrawer] = useState(false)
  const warrantyHistoryItems = [
    { id: 1, roNumber: 'RO#128484', bckNumber: '51k1-3432', titsNumber: 'RN2KW5711', vinNumber: '01K1234', carColor: 'Màu xanh - 343', carType: 'Xe du lịch', kmNumber: '30.000 KM', serviceType: 'Bảo hành định kỳ', price: '21/02/2022' },
    { id: 2, roNumber: 'RO#128484', bckNumber: '51k1-3432', titsNumber: 'RN2KW5711', vinNumber: '01K1234', carColor: 'Màu xanh - 343', carType: 'Xe du lịch', kmNumber: '30.000 KM', serviceType: 'Bảo hành định kỳ', price: '21/02/2022' },
    { id: 3, roNumber: 'RO#128484', bckNumber: '51k1-3432', titsNumber: 'RN2KW5711', vinNumber: '01K1234', carColor: 'Màu xanh - 343', carType: 'Xe du lịch', kmNumber: '30.000 KM', serviceType: 'Bảo hành định kỳ', price: '21/02/2022' },
  ]

  // ORDER HISTORY
  const [showOrderHistoryDrawer, setShowOrderHistoryDrawer] = useState(false)
  const orderHistoryItems = [
    { id: 1, orderCode: '#08033333', srdlCode: '#SR099333', quantity: '01', quantityDKDV: '01', paymentMethod: 'Trả thẳng', dateGDTD: '21/02/2022', dateDNHS: '21/02/2022', dateXuat: '21/02/2022', },
  ]


  const [istab, setIstab] = useState<string>('xe-dang-su-dung')
  return (
    <>
      {/*chi tieết xe đang sử dụng  */}
      <OwnedCarDrawer
        show={showOwnedCarDrawer}
        infoCarInUseHistory={infoCarInUseHistory}
        onClose={() => setShowOwnedCarDrawer(false)}
      />
      {/* Chi tiết xe quan tâm */}
      <FavoriteCarDrawer
        show={showFavoriteCarDrawer}
        inforCarInterested={inforCarInterested}

        onClose={() => setShowFavoriteCarDrawer(false)}
      />

      {/* WARRANTY HISTORY DRAWER */}
      <WarrantyHistoryDrawer
        show={showWarrantyHistoryDrawer}
        onClose={() => setShowWarrantyHistoryDrawer(false)}
      />

      {/* ORDER HISTORY DRAWER */}
      <OrderHistoryDrawer
        show={showOrderHistoryDrawer}
        onClose={() => setShowOrderHistoryDrawer(false)}
      />

      <ModalRestoreCustomer
        isOpen={openRestoreListCustomer}
        title="Bạn có chắc chắn khôi phục khách hàng?"
        titleDelete="Khôi phục"
        content="Bạn có muốn khôi phục bản ghi đã chọn?"
        closeModal={() => setOpenRestoreListCustomer(false)}
        onConfirm={onConfirmRestore}
      />

      <div className="information-tab">
        <div className="information-tab__content">
          <div className="information-tab__content-left">
            <div className="block">
              <span className="font-bold">Thông tin cá nhân</span>
            </div>
            <div className="information-table-show v2">
              {
                value.detail && value.detail.customer &&
                <>
                  <div className='item'>
                    <span className="item-left no-wrap">Tên khách hàng</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.address}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Giới tính</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.district}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Điện thoại</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.province}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Tỉnh / Thành phố</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.unknown_field_35}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Quận / huyện</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.phone}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Địa chỉ</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.unknown_field_9}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Nhân viên</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.unknown_field_4}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Tên đơn vị</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.interest}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Ngày lập KH</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.warehouse_field_1}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Điểm bán hàng</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.unknown_field_5}</span>
                    </div>
                  </div>

                  <div className='item'>
                    <span className="item-left">Kênh thông tin</span>
                    <div className="item-right">
                      <span className='neutral-gray-400'>{value.detail.customer.unknown_field_8}</span>
                    </div>
                  </div>

                  {/* {value.col
                    .filter((col: any) => col.column !== "customer_code")
                    .map((col: any, index: number) => (
                      <div className="item" key={index}>
                        <span className="item-left">{col.name} # {col.column}</span>
                        <div className="item-right">
                          <span className="neutral-gray-400">
                            {value.detail.customer[col.column]}
                          </span>
                        </div>
                      </div>
                    ))
                  } */}

                </>
              }
            </div>
          </div>

          <div className="information-tab__content-right">
            {
              !infoCustomer?.businessCheck
                ? <RelativeCard
                  nguoiLienHe={value.detail.nguoi_lien_he || []}
                  title='Danh sách người liên hệ'
                  infoCustomer={infoCustomer}
                  listRelativeCustomer={listRelativeCustomer}
                  listBusinessCustomer={listBusiness}

                  resultSubmitFormModalAddRelative={resultSubmitFormModalAddRelative}
                  resultSubmitFormModalUpdateRelative={resultSubmitFormModalAddRelative}
                  resultSubmitFormModalDeleteRelative={resultSubmitFormModalAddRelative}

                  resultSubmitFormModalAddBusiness={resultSubmitFormModalAddBusiness}
                  resultSubmitFormModalUpdateBusiness={resultSubmitFormModalAddBusiness}
                  resultSubmitFormModalDeleteBusiness={resultSubmitFormModalAddBusiness}
                />
                : <BusinessCard
                  infoCustomer={infoCustomer}
                  listBusinessCustomer={listBusinessCustomer}

                  resultSubmitFormModalAddBusinessCustomer={resultSubmitFormModalAddBusinessCustomer}
                  resultSubmitFormModalUpdateBusinessCustomer={resultSubmitFormModalAddBusinessCustomer}
                  resultSubmitFormModalDeleteBusinessCustomer={resultSubmitFormModalAddBusinessCustomer}


                />
            }

          </div>
        </div>

        {
          istab === 'xe-dang-su-dung' &&
          <PoolingDataHistoryCard
            value={{ ...value, group: true, action: true }}
            nameTableCache="TbCachePoolingDataCarList1"
            listData={value.detail.cars_dang_su_dung ?? []}
            istab={istab}
            onChange={(data, type) => {
              if (type === 'tabchange') {
                setIstab(data);
              }
              if (type === 'newDataJson') {
                onChange?.(data, type);
              }
            }}
          />
        }

        {
          istab === 'xe-so-hu' &&
          <PoolingDataHistoryCard
            value={{ ...value, group: true }}
            nameTableCache="TbCachePoolingDataCarList2"
            listData={value.detail.cars_so_huu ?? []}
            istab={istab}
            onChange={(data, type) => {
              if (type === 'tabchange') {
                setIstab(data);
              }
              if (type === 'newDataJson') {
                onChange?.(data, type);
              }
            }}
          />
        }

        {
          istab === 'xe-quan-tam' &&
          <PoolingDataHistoryCard
            value={{ ...value, group: true }}
            nameTableCache="TbCachePoolingDataCarList3"
            listData={value.detail.cars_quan_tam ?? []}
            istab={istab}
            onChange={(data, type) => {
              if (type === 'tabchange') {
                setIstab(data);
              }
              if (type === 'newDataJson') {
                onChange?.(data, type);
              }
            }}
          />
        }

        {/* <PoolingDataHistoryCard
          value={{ ...value }}
          title='Thông tin bảo hành - bảo dưỡng'
          nameTableCache="TbCachePoolingDataHistoryCard"
          listData={value.detail.bao_duong_xe ?? []}
          onChange={(data, type) => {
            if (type === 'newDataJson') {
              onChange?.(data, type);
            }
          }}
        /> */}

        <PoolingDataHistoryCard
          value={{ ...value }}
          title='Danh sách hóa đơn'
          nameTableCache="TbCacheHistoryOrderCar"
          listData={value.detail.history_buys ?? []}
          onChange={(data, type) => {
            if (type === 'newDataJson') {
              onChange?.(data, type);
            }
          }}
        />
      </div >

      {
        isInfoPopupShow
          ? <VehicleInfoPopup
            className="show"
            data={data}
            onClose={() => { setInfoPopupShow(false) }}
            dataHistoryMaintenance={dataHistoryMaintenance ?? []
            }
            onShowHistory={() => { setWarrantyHistoryShow(true) }}
          />
          : null
      }
      {
        isWarrantyHistoryShow
          ? <WarrantyHistoryPopup
            className="show"
            onClose={() => { setWarrantyHistoryShow(false) }}
            // setPagination={setPagination}
            customerId={infoCustomer?.id.toString()}
            cardId={data?.carId.toString()}
          />
          : null
      }
      {
        isBenefitPopupShow
          ? <RankBenefitPopup
            className="show"
            infoCardCustomer={infoCardCustomer}
            onClose={() => { setBenefitPopupShow(false) }}
          />
          : null
      }



    </>
  );
}

export default InformationTab;
